import type { ProfileFormData } from './types';

interface Props {
  ownerName: string;
  data: ProfileFormData;
  onChange: (patch: Partial<ProfileFormData>) => void;
}

export function EducationStep({ ownerName, data, onChange }: Props) {
  return (
    <div className="space-y-8">
      <h2 className="font-bold text-3xl">{ownerName}.edu</h2>

      <div className="space-y-6 text-secondary-foreground">
        <p>
          universidad, bootcamp, otro? describe de forma{' '}
          <span className="text-foreground">minimalista</span> qué y donde has
          estudiado, incluyendo años.
        </p>
      </div>

      <div className="space-y-4">
        <div className="block font-semibold text-sm">educación *</div>
        <textarea
          placeholder=""
          value={data.education}
          onChange={(e) => onChange({ education: e.target.value })}
          className="min-h-[150px] w-full rounded border border-border bg-card px-4 py-3 text-foreground placeholder-secondary-foreground focus:border-primary focus:outline-none"
        />
      </div>
    </div>
  );
}
